import { render, staticRenderFns } from "./RequestsCategory.vue?vue&type=template&id=15cf30df&scoped=true"
import script from "./RequestsCategory.vue?vue&type=script&lang=js"
export * from "./RequestsCategory.vue?vue&type=script&lang=js"
import style0 from "./RequestsCategory.vue?vue&type=style&index=0&id=15cf30df&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cf30df",
  null
  
)

export default component.exports